export default {
  getAutomatedResponse: (state) => state.automatedResponse,
};
